export default "/images/8418070208b881333ccec5bc2b30c767.avif";